import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ProjectGridComponent } from './project-grid.component';
import { GridCellDirective } from './grid-cell.directive';
import { I18nModule } from '../i18n/i18n.module';

/**
 * The grid, packaged so any module can host it.
 *
 * It was declared directly in AppModule, which is fine while one screen uses it.
 * The admin area is LAZY-LOADED and gets its own template scope, so a component
 * declared in AppModule is invisible there — the same NG8004 the i18n pipes hit.
 * Declaring it twice is not an option: a component belongs to exactly one module.
 */
@NgModule({
  imports: [CommonModule, FormsModule, I18nModule],
  declarations: [ProjectGridComponent, GridCellDirective],
  exports: [ProjectGridComponent, GridCellDirective],
})
export class ProjectGridModule {}
